<template>
  <router-link
    :to="`/intervenants/${authorMeta.slug}`"
    class="v-container"> <img
      v-if="authorPicture"
      :src="authorPicture.file.url"
      alt="">
    <div class="v-content">{{ authorMeta.firstname }} {{ authorMeta.lastname }}</div>
  </router-link>
</template>

<style scoped>
img {
  width: 40px;
  margin-right: 1em;
}
.v-container {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  margin-right: 1em;
}
.v-content {
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  min-width: 100px;
}
</style>

<script>
import { getEntry, getAsset } from "../../utils/contentful";

export default {
  name: "Author",
  props: {
    includes: {
      type: Object
    },
    author: {
      type: Object
    }
  },
  computed: {
    authorMeta() {
      return getEntry(this.includes, this.author.sys.id).fields;
    },
    authorPicture() {
      return (
        this.authorMeta.authorPicture &&
        getAsset(this.includes, this.authorMeta.authorPicture.sys.id).fields
      );
    }
  }
};
</script>

<style scoped>
</style>
